import {BuyBonusBalanceView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceView';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobileLandscape';
import {Sprite} from 'pixi.js';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {DeviceType, ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';

export class BuyBonusBalanceViewLandscape extends BuyBonusBalanceView {
    public static readonly NAME: symbol = Symbol('BuyBonusBalanceViewLandscape');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;
    public static layer = LAYERS.OVER_KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }
}
